import { FunctionsFetchError, FunctionsHttpError, FunctionsRelayError } from '@supabase/functions-js';

// Traduz os erros que supabase.functions.invoke() pode lançar em mensagens
// específicas o suficiente pra saber se é "função não publicada", "erro de rede"
// ou o erro de negócio real que a função devolveu no corpo (nossas functions
// sempre respondem { success: false, error: "..." } com status != 2xx).
export async function getFunctionErrorMessage(error: unknown, fallback = 'Erro inesperado.'): Promise<string> {
    if (error instanceof FunctionsHttpError) {
        try {
            const body = await error.context.clone().json();
            if (body?.error) return body.error;
        } catch {
            // corpo não é JSON ou já foi consumido — cai no fallback abaixo
        }
        return `A função retornou um erro (HTTP ${error.context.status}). Tente novamente ou contate o suporte.`;
    }
    if (error instanceof FunctionsRelayError) {
        return 'O servidor não conseguiu encaminhar a requisição para a função. Tente novamente em instantes.';
    }
    if (error instanceof FunctionsFetchError) {
        return 'Não foi possível conectar à função no servidor — ela pode ainda não estar publicada, ou houve uma falha de rede/CORS. Contate o suporte se persistir.';
    }
    if (error instanceof Error && error.message) return error.message;
    return fallback;
}